import { createFileRoute } from "@tanstack/react-router"
import QuantitiesTab from "~/components/purchase-plan/QuantitiesTab"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute(
  "/_auth/procurement/supply-plan/$purchasePlanId/_layout/quantities",
)({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Supply Plan - Quantities")

  return <QuantitiesTab />
}
